import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaChalkboardTeacher,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ElearningVideoProductionInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="E-learning Video Production in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Engage Your Audience</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">E-learning Video Production</span> in
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in professional e-learning video
            production in **Dubai**, creating engaging, high-quality videos that
            enhance learning experiences and captivate audiences. Elevate your
            educational content with our expert services.
          </Description>
        }
        // For the Hero Section
        imageSrcs={[
          "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1610484826967-09c5720778c7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1623039405147-547794f92e9e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Produce Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert E-learning Video Production in Dubai"
        description="We craft educational videos with professionalism and creativity."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "High-Quality Production",
            description:
              "Crisp visuals and clear audio for impactful learning.",
          },
          {
            icon: <FaChalkboardTeacher color="#ff5464" size={40} />,
            title: "Engaging Content",
            description: "Interactive videos that keep learners focused.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Creative Storytelling",
            description: "Compelling narratives that enhance understanding.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Timely delivery without compromising quality.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Cross-Platform Compatibility",
            description: "Videos optimized for all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Educators",
            description: "Dubai’s choice for e-learning video production.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Professional Production Process"
        description={
          <Description>
            We create e-learning videos with a streamlined approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your educational goals.</li>
              <li>Scripting: Craft engaging and informative scripts.</li>
              <li>
                Filming: Capture high-quality footage with professional
                equipment.
              </li>
              <li>Editing: Enhance with visuals, animations, and sound.</li>
              <li>Review: Ensure alignment with your vision.</li>
              <li>Delivery: Provide polished videos ready for use.</li>
            </ul>
          </Description>
        }
        // For the Our Process Section
        imageSrcs={[
          "https://images.unsplash.com/photo-1610821678660-aa33854d5a36?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1587614382346-4ec70e388b28?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Educational Wins in Dubai"
        description="Our videos have transformed e-learning experiences."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Increased Engagement",
            description: "Boosted learner retention by 40%.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Authority",
            description: "Elevated a Dubai institute’s reputation.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% approval from educational clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Professional Videos?</Subheading>}
        heading="E-learning Video Production in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for professional e-learning video
            production in Dubai. Create engaging, high-quality educational
            content—contact us today!
          </Description>
        }
        // For the Call-to-Action Section
        imageSrcs={[
          "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1581078427855-1337af4a50c1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1538092547879-34b0b5fe9841?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
